import React from 'react';
import styles from './house.module.scss';

const imagePath = `/watercycle/build/assets/images`;

interface Props {
  imageName: string;
}

export const HouseImage: React.FC<Props> = React.forwardRef<HTMLPictureElement, Props>(({ imageName }, ref) => {
  return (
    <picture className={styles.image} ref={ref}>
      <source srcSet={`${imagePath}/${imageName}.png`} type="image/jpeg" />
      <img src={`${imagePath}/${imageName}.png`} alt="House illustration" />
    </picture>
  );
});
